import { Bot, FolderKanban, Sun, Moon, Accessibility } from "lucide-react";
import { BrandMark } from "./Brand";
import { LANGS, t } from "@/lib/i18n";

const LINKS = [
  ["#mapa-seccion", "nav.map"],
  ["#clara", "nav.ai"],
  ["#como-funciona", "nav.how"],
  ["#adultos-mayores", "nav.senior"],
];

const LangInline = ({ lang, setLang }) => (
  <div data-testid="language-switcher" className="flex items-center gap-1.5 text-[11px] font-semibold tracking-[0.15em]">
    {LANGS.map((l, i) => (
      <span key={l.code} className="flex items-center gap-1.5">
        {i > 0 && <span className="text-ac-faint">/</span>}
        <button data-testid={`language-option-${l.code}`} onClick={() => setLang(l.code)} aria-pressed={lang === l.code} className={`transition-colors ${lang === l.code ? "text-[color:var(--ac-eyebrow)]" : "text-ac-muted hover:text-ac-ink"}`}>
          {l.short}
        </button>
      </span>
    ))}
  </div>
);

export const SiteHeader = ({ guide, lang, setLang, theme, toggleTheme, onOpenChat, onOpenCases, casesCount }) => (
  <header className="sticky top-0 z-30 border-b border-ac-line bg-ac-band-glass backdrop-blur-xl">
    <div className="mx-auto flex h-16 max-w-[1500px] items-center justify-between gap-4 px-4 sm:px-8">
      <a href="#inicio" data-testid="brand-logo" className="group flex items-center gap-2.5">
        <BrandMark className="h-8 w-8 transition-transform group-hover:-translate-y-0.5" />
        <span className="font-mark text-lg font-bold text-ac-ink">Aclarate</span>
      </a>
      <nav className="hidden items-center gap-8 lg:flex">
        {LINKS.map(([href, k]) => (
          <a key={href} href={href} data-testid={`nav-link-${href.slice(1)}`} className="ac-nav-link">{t(k)}</a>
        ))}
        <button data-testid="nav-cases-button" onClick={onOpenCases} className="ac-nav-link flex items-center gap-2">
          {t("nav.cases")}
          {casesCount > 0 && <span data-testid="nav-cases-count" className="grid h-5 min-w-5 place-items-center rounded-full bg-ac-accent px-1 font-mono text-[10px] font-bold tracking-normal text-white">{casesCount}</span>}
        </button>
      </nav>
      <div className="flex items-center gap-3">
        <span className="hidden sm:block"><LangInline lang={lang} setLang={setLang} /></span>
        <button data-testid="voice-mode-toggle" aria-pressed={guide.active} onClick={() => (guide.active ? guide.stop(true) : guide.start())} aria-label={t("guide.toggle")} title={`${t("guide.toggle")} (V)`}
          className={`grid h-9 w-9 place-items-center rounded-full border transition-colors ${guide.active ? "border-ac-primary bg-ac-primary text-white" : "border-ac-line2 text-ac-text hover:border-ac-primary hover:text-ac-primary"}`}>
          <Accessibility className="h-4 w-4" />
        </button>
        <button data-testid="theme-toggle" data-theme={theme} onClick={toggleTheme} aria-label={t("theme.toggle")} title={t("theme.toggle")} className="grid h-9 w-9 place-items-center rounded-full border border-ac-line2 text-ac-text transition-colors hover:border-ac-primary hover:text-ac-primary">
          {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
        <button data-testid="nav-cases-mobile" onClick={onOpenCases} aria-label={t("nav.cases")} className="grid h-9 w-9 place-items-center rounded-full border border-ac-line2 text-ac-text lg:hidden">
          <FolderKanban className="h-4 w-4" />
        </button>
        <button data-testid="nav-assistant-link" onClick={onOpenChat} className="ac-pill ac-pill-solid !px-5 !py-2.5">
          <Bot className="h-4 w-4 sm:hidden" /><span className="hidden sm:inline">{t("nav.cta")}</span>
        </button>
      </div>
    </div>
    <div className="flex justify-center border-t border-ac-line py-2 sm:hidden"><LangInline lang={lang} setLang={setLang} /></div>
  </header>
);
